let carousel_inner;
let carousel_quarted;

let next_end;
let prev_end;

let postcode_submit = document.querySelector('#postcode-submit');
if(postcode_submit) {
  postcode_submit.addEventListener('click', getCarousel);

  let postcode_input = document.querySelector('#postcode-input');

  postcode_input.addEventListener('keypress', function(e) {
    var key = e.which || e.keyCode;
    if (key === 13) {
      getCarousel();
    }
  });
}


function getCarousel() {
 
 setTimeout(function() {
  const waypoint_active = document.querySelector('.waypoint-active');

  if (waypoint_active) {
    carousel_inner = document.querySelector('.directions-content-inner').clientHeight;
    carousel_quarted = carousel_inner / 4;

    let half_carousel = carousel_quarted * 2;

    next_end = carousel_inner - half_carousel;
    next_end = parseInt('-' + next_end) 

    previous_btn();
    next_btn();
    open_close_btn();

  }
 }, 500);
  
}

function previous_btn() {

  let previous_click = document.querySelector('.directions_prev');

  let click_count = 0;

  previous_click.addEventListener('click', function() {

    let next_click = document.querySelector('.directions_next');

    if (next_click.classList.contains('directions-inactive')) {
      next_click.classList.remove('directions-inactive');
    }


    if (click_count == 2) {
      previous_click.classList.add('directions-inactive');
      click_count = 0;
    } 
    
    let carousel_inner_top = document.querySelector('.directions-content-inner');
  
    let carousel_inner_top_position = parseInt(carousel_inner_top.style.top);

    if (carousel_inner_top_position < 0) {
      carousel_inner_top_position = carousel_inner_top_position + carousel_quarted + 'px';
      carousel_inner_top.style.top = carousel_inner_top_position;
    } 

    click_count++;  
    
  });
}


function next_btn() {

  let next_click = document.querySelector('.directions_next');

  let click_count = 0;

  next_click.addEventListener('click', function() {

    let previous_click = document.querySelector('.directions_prev');

    if (previous_click.classList.contains('directions-inactive')) {
      previous_click.classList.remove('directions-inactive');
    }
  
  if (click_count == 2) {
    next_click.classList.add('directions-inactive');
    click_count = 0;
  } 

  //Get the top position of inner item
  let carousel_inner_top = document.querySelector('.directions-content-inner');
  
  let carousel_inner_top_position = parseInt(carousel_inner_top.style.top);

  if (carousel_inner_top_position > next_end) {
    carousel_inner_top_position = carousel_inner_top_position - carousel_quarted + 'px';
    carousel_inner_top.style.top = carousel_inner_top_position;
  } 

  click_count++;  

  });
}


function open_close_btn() {

  let open_close = document.querySelector('.directions-panel-tab');

  let directions_container = document.querySelector('.directions-panel-container');

  open_close.addEventListener('click', function() {
    
    if (directions_container.classList.contains('viewable-directions')) {
      directions_container.classList.add('hidden-directions');
      directions_container.classList.remove('viewable-directions');
      directions_container.classList.remove('active-directions');
      open_close.innerHTML = 'Open';
    } else {
      directions_container.classList.remove('hidden-directions');
      directions_container.classList.add('viewable-directions');
      directions_container.classList.add('active-directions');
       open_close.innerHTML = 'Close';
    }
  
  });
}




